import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import { defaultMetatags } from "@/lib/constants";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(title) {
  const keywords = title !== null && title !== void 0 && title.meta_keywords && (title === null || title === void 0 ? void 0 : title.meta_keywords.length) > 0 ? title.meta_keywords.join(",") : null;
  return {
    title: `${title.name}の動画一覧 | SPOOX(スプークス)`,
    keywords: keywords || defaultMetatags.vod.keywords,
    description: `${title.name}の動画一覧 。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！月額見放題でも、1作品から購入でも楽しめます。`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.title(title.id)}`
    },
    twitter: {
      card: "summary"
    }
  };
}
export default function TitleMetaTags(_ref) {
  let {
    title
  } = _ref;
  const props = tags(title);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}